<template>
	<div v-if="this.deleted === false" :debugid="'premedia-'+this.id" class="job-premedia__premedia-group__item">
		<v-card>

            <!-- top right icons: DELETE OR APPROVE CHECKMARK -->
			<div class="card-actions">
				<div
					v-if="isEditing"
					class="action-btn delete"
					@click="deleteRowItem">
					<div><v-icon class="white--text" size="15px">close</v-icon></div>
				</div>
				<div 
					v-if="!isEditing && canViewApproved"
					:class="['action-btn', 'approve', {approved:isApproved}, {'can-not-approve':!canApprove}]"
					@click="toggleApproved">
					<div><v-icon class="white--text" size="15px">check</v-icon></div>
				</div> 
			</div>

            <div class="type-default">
                <div class="all-types">
                    <v-img
                            class="premedia-img"
                            container
                            :src="loadImage"
                            @error="imageLoad_OnError"
                            @success="imageLoad_OnSuccess"
                    ></v-img>
                    <previewable-file-item v-if="type===3"
                            :file="item.file"
                            :attachment="item"/>
                </div>

                <v-card-text
                    :class="['card-title', cardtype, 'type-'+type]">
                    <h3 v-if="type!==3" class="body-1 premedia-title">{{title}}</h3>
                    <div class="item-meta">
                        <div v-if="begins" class="premedia-begins">Begins {{begins}}</div>
                        <div v-if="expires" class="premedia-expires">Expires {{expires}}</div>
                        <v-text-field
                            v-if="isEditing"
                            class="caption premedia-note input"
                            flat
                            maxlength="20"
                            height="18"
                            color="grey lighten-2"
                            placeholder="Add Note"
                            v-model="premediaItemNote"
                            />
                        <div v-else class="caption premedia-note">{{ getNote }}</div>
                    </div>
                </v-card-text>
            </div>

		</v-card>
	</div>
</template>


<script>
	import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

	import { 
			VUEX_PREMEDIA_DELETE_ITEM,
			VUEX_PREMEDIA_EDIT_ITEM,
            VUEX_PREMEDIA_REMOVE_FILE
    } from '@/store/constants/premedia'

    import {
        VUEX_ATTACHMENT_QUEUE_MANAGER_REMOVE_FILE
    } from '@/store/constants/attachment_queue_manager'

    import AttachmentFileItem from '@/components/ui/_global/Attachment_File_Item.vue'
    import PreviewableFileItem from '@/components/ui/_global/Previewable_File_Item.vue'

	export default {
		name: 'job-premedia-premediaGroup-item',

        components: {
            'previewable-file-item': PreviewableFileItem,
            'attachment-file-item': AttachmentFileItem,
        },
		props: {
			cardtype: {
				type: String,
				required: true
			},
			title: {
				type: String,
				required: false
			},
			id: {
				type: String,
				required: false,
				default: null
			},
            tempId: {
                type: String,
                required: false,
                default: null
            },
			rowId: {
				type: String,
				required: false,
				default: null
			},
			rowIndex: {
				type: Number,
                required: true,
			},
			expires: {
				type: [String, null],
				required: false,
				default: null
			},
            begins: {
                type: [String, null],
                required: false,
                default: null
            },
			note: {
				type: String,
				default: 'Add Note'
			},
            type: {
                type: [Number, null],
                default: null
            },
			approved: {
				type: Boolean,
				default: false
			},
			canApprove: {
				type: Boolean,
				required: false,
				default: false
			},
			canViewApproved: {
				type: Boolean,
				required: false,
				default: true
			},
			img: {
				type: String,
				required: true
			},
			isEditing: {
				type: Boolean,
				default: false
			},
            item: {
                type: Object,
            },

		},

		data:() => ({
			imageLoadFailed: false,
			isApproved: false,
            premediaAttachmentImgLoaded: null,
            deleted:false,
            noteEditing:'',
            debounceSearchTimer:'',
		}),


		computed: {
            ...mapGetters({
                getRowItemById: 'getRowItemById',
            }),

			premediaItemNote: {
				get() {
				    return this.getNote
                },
				set(val) {
                    clearTimeout(this.debounceSearchTimer)
                    this.debounceSearchTimer = setTimeout(function () {
                        this.$store.dispatch('VUEX_PREMEDIA_UPDATE_ITEM_PROP', {
                            id:             this.id,
                            temp_id:        this.tempId,
                            data:{
                                note:val
                            }
                        })
                    }.bind(this), 800)
				}
			},
			loadImage() {
                let ret = require('@/assets/images/no-preview-available.jpg')
                if (!this.imageLoadFailed) {
                    if (this.item && this.item.img) {
                        ret = this.item.img
                    } else {
                        ret = this.img
                    }
                }
                return ret
            },
            getNote() {
                if (this.id) {
                    var obj = this.getRowItemById(this.rowIndex, this.id)
                    return (obj) ? obj.note : ""
                } else {
                    return (this.note) ? this.note : ""
                }
            },
		},

		mounted() {
			this.isApproved = this.approved
		},

		methods: {
			...mapActions({
				editItem: VUEX_PREMEDIA_EDIT_ITEM,
				deleteItem: VUEX_PREMEDIA_DELETE_ITEM,
                removeAttachment: VUEX_PREMEDIA_REMOVE_FILE,
                removeAttachmentFromAQM: VUEX_ATTACHMENT_QUEUE_MANAGER_REMOVE_FILE,
			}),

            toggleApproved() {
                if (!this.canApprove) return

				let approved = this.isApproved = !this.isApproved

				this.editItem({
					id:          this.id,
					row_id:      this.rowId,
					row_index:   this.rowIndex,
                    is_approved: approved,
				})
			},

			deleteRowItem() {
			    if (this.type===3) {
                    this.removePremediaAttachment(this.item)
                } else {
                    this.deleteItem({
                        row_id: this.rowId,
                        id: this.id,
                        temp_id: this.tempId
                    })
                }
                this.deleted = true
			},

            removePremediaAttachment(data) {
                if (data.attach_to !== undefined) {
                    // remove newly attached items from AQM
                    let d = {
                        model: data.attach_to.model,
                        model_id: this.rowId,
                        file_id: data.id,
                        data:data,
                    }

                    //kill it
                    this.removeAttachmentFromAQM(d)

                } else {
                    // remove exiting items
                    let d = {
                        model: SILA_FILE_ATTACHMENT_MODEL_JOB_PREMEDIA_ROW,
                        model_id: this.rowId,
                        file_id: data.file_id,
                        data:data
                    }

                    //kill it
                    this.removeAttachment(d)

                }
            },


            imageLoad_OnError() {
				this.imageLoadFailed = true
			},
            imageLoad_OnSuccess() {
                this.imageLoadFailed = false
            }


		}
	}
</script>